<template>
    <header
        class="page-header"
        :class="[
            hasNotificationBar ? 'has-notification-bar' : '',
            shouldScroll ? '' : '-scroll',
        ]"
    >
        <div class="container header-content">
            <div class="button-container" v-if="hasButtonStart">
                <slot name="button-start"></slot>
            </div>
            <div v-if="title || subtitle">
                <component
                    :is="headingType"
                    class="title ellipsis"
                    v-if="title"
                >
                    <span v-html="title"></span>
                </component>

                <p class="subtitle" v-if="subtitle" v-html="subtitle"></p>
            </div>
            <slot name="header-content"></slot>
            <div class="button-container" v-if="hasButtonStart || hasButtonEnd">
                <slot name="button-end"></slot>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: "Header",
    props: {
        title: String,
        subtitle: String,
        headingType: {
            type: String,
            default: "h1",
        },
        hasNotificationBar: {
            type: Boolean,
            default: false,
        },
        scrollPosition: {
            default: 0,
            type: Number,
        },
    },
    data() {
        return {
            shouldScroll: true,
            scrollContainer:
                document.querySelector(".page-body > .view") || window,
            headerHeight: 0,
        };
    },
    computed: {
        hasHeaderContent() {
            return !!this.$slots["header-content"];
        },
        hasButtonStart() {
            return !!this.$slots["button-start"];
        },
        hasButtonEnd() {
            return !!this.$slots["button-end"];
        },
    },
    methods: {
        onPageScroll() {
            this.shouldScroll =
                this.scrollContainer.scrollTop <=
                this.scrollPosition - this.headerHeight;
        },
    },
    mounted() {
        if (this.scrollPosition > 0) {
            this.scrollContainer.addEventListener("scroll", this.onPageScroll);
        }

        this.headerHeight = this.$el.offsetHeight;

        if (!this.$el.closest(".modal")) {
            document.documentElement.style.setProperty(
                "--header-height",
                `${this.headerHeight}px`
            );
        }
    },
    unmounted() {
        if (this.scrollPosition > 0) {
            this.scrollContainer.removeEventListener(
                "scroll",
                this.onPageScroll
            );
        }
    },
};
</script>

<style lang="scss">
@use "index";
</style>
